var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"placeholder",class:{ animation: _vm.loading }},[_c('i',{class:_vm.Icon.LocationPin})])
}
var staticRenderFns = []

export { render, staticRenderFns }